export interface CmsInstallationInstructionPanel {
  installationInstructionPanelBody: string;
  installationInstructionPanelTitle: string;
}
